var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col rounded-xl border border-slate-200 bg-slate-50 p-4"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }